import { Pencil, X } from "lucide-react";
import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { createNewEntryToMockTopic } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import Snackbar from "../../../../Snackbar";
export default function QuizTopicCard({
  topic_name,
  topic_description,
  difficulty_level,setCurrentTopic,item,deleteCurrentTopic,questionId
}) {
  const difficultyClass = {
    easy: "difficulty-easy",
    medium: "difficulty-medium",
    hard: "difficulty-hard",
  }[difficulty_level] || "difficulty-default";

  
  
      const App = useSelector((state)=>state?.app?.app);
      const [Courses,setCourses] =useState([])
      const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
       const [animate, setAnimate] = useState(false);
       
      const dispatch = useDispatch();  
    
      const currentToken = useSelector((state)=>state?.user?.user?.token);
      const user_email = useSelector((state)=>state?.user?.user?.user_email
     );
     const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     const appId = useSelector((state)=>state?.app?.app?.ID);
     const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
          
     const [snackbarVisible, setSnackbarVisible] = useState(false);
      
      const [snackbarColor, setSnackbarColor] = useState("#958FDA");
        const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    
    const [visibility ,setVisibility] =useState("public");
    const [status ,setStatus] =useState("active");
        const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
          
         const [itemArr, setItemArr] = useState([]);
         const [currentEntryObject, setCurrentEntryObject] = useState({});
         const [checkboxState ,setCheckboxState] =useState(false)
    
        const showSnackbar = () => {
       setSnackbarVisible(true);
     };
     
      const hideSnackbar = () => {
       setSnackbarVisible(false);
     };
     const setCurrentCourse=()=>{
      dispatch({
          type: "COURSEDATA",
          
          payload:""
        });  
  }
         const [loader , setLoader] =useState({status:false});
        const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          } 
      
           
          
             
      const userdata = useSelector((state)=>state?.user?.user);
      


function isQuestionInArray(itemArr, questionId) {
  if (!Array.isArray(itemArr)) return false;
  const qid = String(questionId).trim();
  return itemArr.some(q => String(q.question_id).trim() === qid);
}
function getQuestionEntryIdById(itemArr, questionId) {
  const found = itemArr.find(item => String(item.question_id) === String(questionId));
  return found ? found.entry_id : null;
}




          const handleCreateNewEntryToTopic=()=>{
             
             
             setLoader({status:true});
             
               const apiData = dispatch(createNewEntryToMockTopic({questionId:questionId,
                           topicId:item?.id,userEmail:user_email?user_email:"",
                           currentToken:currentToken?currentToken:"",visibility:visibility,status:status,menuOrder:0,
                           editType:"create",appToken:AppToken,appId:appId}
                           ));
               /* get response as Promise   */
               apiData.then(response => {
                 if(response){   
                    
                   if(response?.question){
                    
                 setResponseMessage(response?.message);
                 setSnackbarColor("rgba(144, 202, 249,1)");
              
                setTimeout(()=>{
                     setCheckboxState(true) ;
                 },1000)
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
             },1000)
                }else{
                 setResponseMessage(response?.message);
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                }
                   
                
                if(response?.logout){
                
                 setResponseMessage("You are Logged Out!!!");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 setTimeout(()=>{
                   dispatch({type:"LOGOUT"});
             
                 },3000)
                 
               }
             /* resetting Login input Fields */
             
                 }else{
                   setResponseMessage("Something Went Wrong...");
                   
                   setSnackbarColor("#958FDA");
                
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)    }
             
               }).catch(error => {
              
                 //popup of error Info
                 setResponseMessage("Something Went Wrong...");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 console.error(error);
               });
              
               }
          const handleSoftDeleteEntryFromTopic=()=>{
             
             setLoader({status:true});
             
               const apiData = dispatch(createNewEntryToMockTopic({questionId:questionId,entryId: getQuestionEntryIdById(itemArr, questionId),
                           topicId:item?.id,userEmail:user_email?user_email:"",
                           currentToken:currentToken?currentToken:"",visibility:visibility,status:status,menuOrder:0,
                           editType:"delete",appToken:AppToken,appId:appId}
                           ));
               /* get response as Promise   */
               apiData.then(response => {
                 if(response){   
                    
                   if(response?.question){
                    
                 setResponseMessage(response?.message);
                 setSnackbarColor("rgba(144, 202, 249,1)");
              
                setTimeout(()=>{
                     setCheckboxState(false) ;
                 },1000)
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
             },1000)
                }else{
                      
                 setResponseMessage(response?.message);
                 
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                }
                   
                
                if(response?.logout){
                
                 setResponseMessage("You are Logged Out!!!");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 setTimeout(()=>{
                   dispatch({type:"LOGOUT"});
             
                 },3000)
                 
               }
             /* resetting Login input Fields */
             
                 }else{
                   setResponseMessage("Something Went Wrong...");
                   
                   setSnackbarColor("#958FDA");
                
                    
               setLoader({status:false});
               
               setSnackbarVisible(true);
               setTimeout(()=>{
                 
                 setSnackbarVisible(false);
                
                  
               },3000)    }
             
               }).catch(error => {
              
                 //popup of error Info
                 setResponseMessage("Something Went Wrong...");
                   
                 setSnackbarColor("#958FDA");
              
                  
             setLoader({status:false});
             
             setSnackbarVisible(true);
             setTimeout(()=>{
               
               setSnackbarVisible(false);
              
                
             },3000)
                 console.error(error);
               });
              
               }

 useEffect(()=>{fireGetAllQuesByTopics();},[checkboxState])
        
     const fireGetAllQuesByTopics=()=>{
       setItemArrLoading([{},{},{},{}])
        setLoader({status:true});
         
          const apiData = dispatch(createNewEntryToMockTopic({
             topicId:item?.id,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",visibility:visibility,status:status,
            editType:"getAllByTopic",appToken:AppToken,appId:appId}
            ));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){   
              if(response?.questions){
                setItemArrLoading([])
         setItemArr(response?.questions);
          setCheckboxState(isQuestionInArray(response?.questions, questionId))
        
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
           
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("#958FDA");
           
               
          setLoader({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("#958FDA");
         
             
        setLoader({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }
                const flattenedData = itemArr!=[]?Object.values(itemArr):'';

  const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';

  return (<>  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}
    <div className="topic-card"> { <div style={{display:"flex",justifyContent:"right",position:"relative",zIndex:"9999999"}} ><X  strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" 
      onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{deleteCurrentTopic(item)}}
      style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"5px",position:"absolute",top:"0px",right:"0px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}} />
            <div
        onClick={()=>{ }} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave}  style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"0px",position:"absolute",top:"0px",left:"60px",
            fontSize:"13px",borderRadius:"5px",color:"#222",fontWeight:"900",borderRadius:"5px",cursor:"pointer"}}> Show All Questions  ({itemArr?.length})</div>
    <Pencil
        onClick={()=>{setCurrentTopic(item) }} 
         onMouseEnter={handleMouseEnter}
                   onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
         color="#222" style={{padding:"4px",background:"rgba(144, 202, 249,0.1)",height:"18px",marginLeft:"30px",position:"absolute",top:"0px",left:"0px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}/>
            
       <label className={"checkbox-outer"}  style={{height:"18px",marginLeft:"0px",position:"absolute",top:"0px",left:"0px",
            fontSize:"13px",borderRadius:"5px",color:"#222",borderRadius:"5px",cursor:"pointer"}}>
                                 <input type={"checkbox"} title={topic_name}
                                                 className="input-textbox"  value={item?.id}
                                                  name={"optionTitle1"} checked={checkboxState}   onChange={e=>{ if(!checkboxState){handleCreateNewEntryToTopic()}else{handleSoftDeleteEntryFromTopic()}  }}/>
                                                   <span class={"square"} style={{borderRadius:"5px",}}></span> </label>     
            </div>}
      <div className="topic-card-header">
        <h3 className="topic-title">{topic_name}</h3>
        <span className={`difficulty-badge ${difficultyClass}`}>
          {difficulty_level}
        </span>
      </div>

      {topic_description && (
        <p className="topic-description">{topic_description}</p>
      )}

    </div>
    <style>{`
    .topic-card {
  background: rgba(144, 202, 249,0.1);
  border: 1px solid rgba(144, 202, 249,1);
  border-radius: 14px;position:retative;
  padding:5px 10px;
  margin: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.25s ease;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
}

.topic-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.topic-card-header { margin-top:30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.topic-title {
  font-size: 1.1rem;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.difficulty-badge {
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 8px;
  text-transform: capitalize;
  font-weight: 500;
}

.difficulty-easy {
  background-color: #e6f8ea;
  color: #228b22;
}

.difficulty-medium {
  background-color: #fff6e5;
  color: #b58900;
}

.difficulty-hard {
  background-color: #fdeaea;
  color: #c0392b;
}

.difficulty-default {
  background-color: #f1f1f1;
  color: #555;
}

.topic-description {
  font-size: 0.9rem;
  color: #555;
  margin: 8px 0 12px;
  line-height: 1.4;
  max-height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topic-footer {
  display: flex;
  justify-content: space-between;
  color: #666;
  font-size: 0.85rem;
  margin-top: 4px;
}

.topic-status {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  font-size: 0.75rem;
  color: #999;
}

.topic-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}

    `}</style>
    
    </>
  );
}
